import { createClient } from "contentful"

export const ContenfulClient = (!import.meta.env.VITE_CONTENTFUL_ACCESS_TOKEN || !import.meta.env.VITE_CONTENTFUL_SPACE_ID) ? undefined : createClient({
  accessToken: import.meta.env.VITE_CONTENTFUL_ACCESS_TOKEN,
  space: import.meta.env.VITE_CONTENTFUL_SPACE_ID,
})
